export type ItemAccountRegisterProps = {
  icon: React.ReactNode
  title: string
  body: string
}

export const ItemAccountRegister = ({
  icon,
  title,
  body,
}: ItemAccountRegisterProps) => {
  return (
    <div className="flex items-center max-w-full h-48">
      <div className="flex justify-center items-center mr-8 w-48 h-48 rounded-full bg-accent1-gradient">
        <span className="text-2xl">{icon}</span>
      </div>
      <div>
        <p className="mb-4 text-[16px] font-bold text-primary">{title}</p>
        <p className="text-xs font-normal text-secondary">{body}</p>
      </div>
    </div>
  )
}
